import LazyComponentLoader from '@/Components/LazyComponentLoader';
import LazyComponentError from '@/Components/LazyComponentError';
import { defineAsyncComponent } from 'vue';

export default function lazyComponent(loader, loadingComponent = LazyComponentLoader, delay = 100) {
    return defineAsyncComponent({
        loader,
        errorComponent: LazyComponentError,
        loadingComponent,
        delay,
        // Don't integrate with parent <Suspense> — these are nested lazy components
        // (charts, editors, etc.) that should load independently with their own loading UI.
        suspensible: false,
    });
}
